"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCourierClient = void 0;

var _urql = require("urql");

require("isomorphic-fetch");

var createCourierClient = function createCourierClient(params, defaults) {
  if ("client" in params) {
    return params.client;
  }

  var headers;
  var jwtParams = params;

  if (jwtParams.authorization) {
    headers = {
      authorization: "Bearer ".concat(jwtParams.authorization)
    };

    if (jwtParams.clientSourceId) {
      headers["x-courier-client-source-id"] = jwtParams.clientSourceId;
    }
  } else {
    var _ref = params,
        clientKey = _ref.clientKey,
        userId = _ref.userId,
        userSignature = _ref.userSignature,
        clientSourceId = _ref.clientSourceId;
    headers = {
      "x-courier-client-key": clientKey,
      "x-courier-user-id": userId
    };

    if (clientSourceId) {
      headers["x-courier-client-source-id"] = clientSourceId;
    }

    if (userSignature) {
      headers["x-courier-user-signature"] = userSignature;
    }

    if (!clientKey || !userId) {
      return;
    }
  }

  return (0, _urql.createClient)({
    url: params.apiUrl || (defaults === null || defaults === void 0 ? void 0 : defaults.apiUrl) || "".concat(undefined || "https://api.courier.com", "/client/q"),
    requestPolicy: "network-only",
    fetchOptions: function fetchOptions() {
      return {
        headers: headers
      };
    }
  });
};

exports.createCourierClient = createCourierClient;